import React from 'react';

const CompleteContract = () => {
    return (
        <div>

        </div>
    )
}
export default CompleteContract;